<template>
 <div>
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
         <div class="searchBox inpBox">
            <div class="item">
              <el-form-item label="上报编号:" prop="reportNo">
              <el-input  placeholder="" v-model="searchFrom.reportNo"></el-input>
            </el-form-item>
            <el-form-item label="船舶流向:" prop="shipFlowName">
              <el-input  placeholder="" v-model="searchFrom.shipFlowName"></el-input>
            </el-form-item>
            <el-form-item label="预计到达时间:" prop="receivingTime">
                <el-date-picker
                  v-model="searchFrom.receivingTime"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
            </div>
        </div>
       <div class="searchBtnBox">
         <el-form-item >
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"  @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
        <el-table-column prop="reportNo" min-width="200"  :formatter="emptyFn" label="上报编号"></el-table-column>
        <el-table-column prop="companyName" min-width="200"  :formatter="emptyFn" label="公司名称"></el-table-column>
        <el-table-column prop="shipFlowName" min-width="200"  :formatter="emptyFn" label="船舶流向"></el-table-column>
        <el-table-column prop="referenceCapacity" width="120" :formatter="emptyFn" label="载重(吨)"></el-table-column>
         <el-table-column prop="shipDateNo" width="200" :show-overflow-tooltip="true" label="航次号"></el-table-column>
        <el-table-column prop="shipName" width="160" :formatter="emptyFn" label="船舶名称"></el-table-column>
         <el-table-column prop="receivingTime" width="170" :formatter="dateFormat"  label="预计到达时间"></el-table-column>
         <el-table-column prop="companyPerson" width="120" :formatter="emptyFn" label="联系人"></el-table-column>
         <el-table-column prop="companyPhone" width="120" :formatter="emptyFn" label="联系电话"></el-table-column>
        <el-table-column prop="createUserName" width="120" :formatter="emptyFn" label="上报人"></el-table-column>
        <el-table-column prop="createTime" width="170" :formatter="dateTimeFormat"  label="上报时间"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { shipperShipDateReportList } from '@/api/shipping'
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
export default {
  data () {
    return {
      h: 500,
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      total: 0,
      btnFlg: [],
      btnIdArr: ['00KP004B001', '00KP004B002', '00KP004B003', '00KP004B004']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/shipingPeiHuo')
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 98) + 'px'
  },
  methods: {
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcodes) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcodes.split(/[(\r\n)\r\n]+/) }
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      shipperShipDateReportList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        createTime: null
      }
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox .el-date-editor{
      width: 350px!important;
}
.imgBox{
  display: flex;
  .item{
    display: flex;
     width: 50%;
     justify-content: space-around;
  }
}
/deep/ .checkboxBox{
  display: flex;
  label{
    flex-shrink: 0;
  }
  .el-checkbox-group{
    width:250px ;
  }
}

</style>
